/* eslint-disable @typescript-eslint/no-explicit-any */

type KeysOfManyMaps<MAPS_GENERIC extends readonly ReadonlyMap<any, any>[]> =
  MAPS_GENERIC[number] extends ReadonlyMap<infer KEY_GENERIC, any>
    ? KEY_GENERIC
    : never

type ValuesOfManyMaps<MAPS_GENERIC extends readonly ReadonlyMap<any, any>[]> =
  MAPS_GENERIC[number] extends ReadonlyMap<any, infer VALUE_GENERIC>
    ? VALUE_GENERIC
    : never

/**
 * Merges multiple maps into a single map.  The resulting map will be typed to the union of the keys and values of the input maps.
 *
 * > IMPORTANT: If there are duplicate keys, the last map in the parameters' key will win.
 */
export function mergeMaps<const MAPS_GENERIC extends ReadonlyMap<any, any>[]>(
  ...maps: [...MAPS_GENERIC]
): Map<KeysOfManyMaps<MAPS_GENERIC>, ValuesOfManyMaps<MAPS_GENERIC>> {
  return new Map(maps.flatMap((m) => [...m]))
}
